import React from 'react';

const ToggleButton = ({ name, onChange, title, text, isChecked, isDisabled = false }) => {
  return (
    <div className="form-check mr-2" style={{ marginTop: 'revert', display: 'inline-block' }}>
      <div className="togglebutton">
        <label>
          <input
            type="checkbox"
            name={name}
            title={title || text}
            onChange={onChange}
            disabled={isDisabled}
            checked={isChecked ? 'checked' : ''}
          />
          <span className="toggle"></span>
          {text || title}
        </label>
      </div>
    </div>
  );
};

export default ToggleButton;
